import React from 'react';
import { Col, Container } from 'react-bootstrap';
import { TopMenu } from '../../shared';

function WebInfoManager() {

  return (
    <>
      <TopMenu />

      <Col lg={12} className='inner-bg'>
        <Container className='middle-content'>
          <div className="page-heading">
            <img src='https://pmfby.amnex.co.in/pmfby/lms/lms-inner-banner.jpg' alt='Inner Banner - LMS' className='img-fluid pb-4' />
            <h4 className="fw-bold mb-2">Web Information Manager</h4>
            <ul className="my-topbreadcrum">
              <li>
                <a
                  href="/lms"

                >Home</a>
              </li>
              &nbsp; / &nbsp;
              <li>Web Information Manager</li>
            </ul>
          </div>
          <div>
            <p className='mbtm0'><strong>WIM for PMFBY</strong></p>

            <p>Joint Secretary (CEO, PMFBY/IC, Credit-II),<br />
              email: ritesh[dot]chauhan[at]gov[dot]in<br />
              Telephone/landline: 23074701, 23074722<br />
              EPBAX: 2183<br />
              Room No: 247</p>
          </div>
        </Container>
      </Col>
    </>
  );
}

export default WebInfoManager;